var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "71px",
    viewBox: "0 0 53 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Filetext") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1423.000000, -114.000000)",
    stroke: "#043F93",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filetext",
    transform: "translate(1424.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0588235,28.2941176 L50.0588235,68.2352941 L0,68.2352941 L0,28.2941176 L0,0 L36.8079585,0 L50.0588235,13.2352941 L50.0588235,28.2941176 Z",
    id: "Rectangle-1948",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4339",
    strokeLinecap: "round",
    points: "36.5294118 13.5294118 50.0588235 13.5294118 36.5294118 0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1996",
    strokeLinecap: "round",
    x: 8.11764706,
    y: 23,
    width: 33.8235294,
    height: 37.8823529
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5882353,29.7647059 L32.4948418,29.7647059",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5882353,37.8823529 L32.4948418,37.8823529",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5882353,46 L32.4948418,46",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5882353,54.1176471 L32.4948418,54.1176471",
    id: "Line",
    strokeLinecap: "square"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployment);
export default __webpack_public_path__ + "static/media/Employment.4df75f9cb8d00f5688e02d2f4eafb40f.svg";
export { ForwardRef as ReactComponent };